<template>
  <div
    class="action-bar"
    :class="classList"
  >
    <div class="counter-label d-flex align-items-center">
      <template v-if="!isCallingReviewOrUnreviewFlag">
        <i18n
          tag="span"
          class="Fuell-Text"
          path="transactions_total_transactions_selected"
        >
          <template v-slot:selectedTransactions>
            <span class="text-primary">{{selectedLabel()}}</span>
          </template>
          <template v-slot:transactionType>
            {{transactionsTypeLabel()}}
          </template>
        </i18n>
      </template>
    </div>
    <div class="actions-container d-flex align-items-center justify-content-evenly ml-3">
      <template v-if="!isCallingReviewOrUnreviewFlag">
        <template v-if="showReviewButton && actionsList.indexOf(BULK_FUNNEL_ACTIONS.APPROVE) !== -1">
          <button
            class="funnel-button mr-2"
            @click="handleSelectedApprove(BULK_FUNNEL_ACTIONS.APPROVE)"
          >
            <img
              :src="require('@/assets/img/icons/funnel/approve.svg')"
              alt=""
            >
            <span class="funnel-button-label">
              {{$t('transactions_funnel_actions_approve')}}
            </span>
          </button>
        </template>
        <template v-if="showUnreviewButton && actionsList.indexOf(BULK_FUNNEL_ACTIONS.UNREVIEW) !== -1">
          <button
            class="funnel-button mr-2"
            @click="handleSelectedTransactionsBulkAction(BULK_FUNNEL_ACTIONS.UNREVIEW)"
          >
            <img
              :src="require('@/assets/img/icons/funnel/unreview.svg')"
              alt=""
            >
            <span class="funnel-button-label">
              {{$t('transactions_funnel_actions_approve_undo')}}
            </span>
          </button>
        </template>
        <template v-if="showRejectButton && actionsList.indexOf(BULK_FUNNEL_ACTIONS.REJECT) !== -1">
          <button
            class="funnel-button mr-2"
            @click="handleSelectedTransactionsBulkAction(BULK_FUNNEL_ACTIONS.REJECT)"
          >
            <img
              :src="require('@/assets/img/icons/funnel/reject.svg')"
              alt=""
            >
            <span class="funnel-button-label">
              {{$t('transactions_funnel_actions_reject')}}
            </span>
          </button>
        </template>
        <template v-if="showLockButton && actionsList.indexOf(BULK_FUNNEL_ACTIONS.LOCK) !== -1">
          <button
            class="funnel-button mr-2"
            @click="handleSelectedTransactionsBulkAction(BULK_FUNNEL_ACTIONS.LOCK)"
          >
            <img
              :src="require('@/assets/img/icons/funnel/lock.svg')"
              alt=""
            >
            <span class="funnel-button-label">
              {{$t('transactions_funnel_actions_lock')}}
            </span>
          </button>
        </template>
        <template v-if="showUnlockButton && actionsList.indexOf(BULK_FUNNEL_ACTIONS.UNLOCK) !== -1">
          <button
            class="funnel-button mr-2"
            @click="handleSelectedTransactionsBulkAction(BULK_FUNNEL_ACTIONS.UNLOCK)"
          >
            <img
              :src="require('@/assets/img/icons/funnel/unlock.svg')"
              alt=""
            >
            <span class="funnel-button-label">
              {{$t('transactions_funnel_actions_unlock')}}
            </span>
          </button>
        </template>
        <template v-if="showAccountButton && actionsList.indexOf(BULK_FUNNEL_ACTIONS.ACCOUNT) !== -1">
          <button
            class="funnel-button "
            @click="handleSelectedTransactionsBulkAction(BULK_FUNNEL_ACTIONS.ACCOUNT)"
          >
            <img
              :src="require('@/assets/img/icons/funnel/account.svg')"
              alt=""
            >
            <span class="funnel-button-label">
              {{$t('transactions_funnel_actions_account')}}
            </span>
          </button>
        </template>
        <template v-if="actionsList.indexOf('EXPORT') !== -1">
          <button
            class="funnel-button"
            @click="exportTransactions()"
          >
            <span class="funnel-button-label">
              {{$t('export_flow_export')}}
            </span>
          </button>
        </template>
      </template>
      <template v-else>
        <spinner :spinnerContainerClass="''" />
      </template>
    </div>
    <confirm-modal
      :open.sync="showConfirmMixedStatusFlag"
      v-if="showConfirmMixedStatusFlag"
      :acceptText="$t('ACTION_CONTINUE')"
      :title="confirmMixedStatusTitle"
      :message="''"
      :dismissText="$t(`ACTION_CANCEL`)"
      ignoreDefaultMessage
      acceptBtnClass="blue"
      modalClass="ModalBox--400"
      @accept="handleAction(showConfirmMixedStatusFlag)"
    >
      <template v-slot:additional>
        <i18n
          tag="p"
          class="Fuell-Text action"
          path="transactions_bulk_action_warning_confirm"
        >
          <template v-slot:selectedTransactionsCount>
            <span class="text-dark">{{selectedTransactions.length}}</span>
          </template>
          <template v-slot:bulkAction>
            <span class="text-primary">{{$t(`transactions_bulk_action_name__${showConfirmMixedStatusFlag}`).toLowerCase()}}</span>
          </template>
          <template v-slot:validAmount>
            <span class="text-primary">{{countReimbursementsByAction(showConfirmMixedStatusFlag)}}</span>
          </template>
        </i18n>
      </template>
    </confirm-modal>
    <confirm-modal
      v-if="showConfirmBulkActionModal"
      @accept="handleSelectedTransactionAction(showConfirmBulkActionModal)"
      @dismiss="showConfirmBulkActionModal = false"
      :message="''"
    >
      <template v-slot:additional>
        <i18n
          tag="span"
          class="Fuell-Text"
          path="transactions_multiple_transactions_action_confirm"
        >
          <template v-slot:transactionsTotalItems>
            <span class="Fuell-Text text-danger">{{transactionsTotalItems}}</span>
          </template>
        </i18n>

      </template>
    </confirm-modal>
    <confirm-modal
      v-if="showConfirmBulkActionModalUsers"
      @accept="handleSelectedTransactionAction(showConfirmBulkActionModalUsers)"
      @dismiss="showConfirmBulkActionModalUsers = false"
      :message="''"
      modalClass="ModalBox--400 center"
      title="transactions_multiple_users_action_title"
      dismissBtnClass="red"
      dismissText="ACTION_CANCEL"
      acceptBtnClass="blue"
      acceptText="transactions_funnel_actions_approve"
    >
      <template v-slot:additional>
        <span class="Fuell-Text">{{$t('transactions_multiple_users_action_confirm')}}</span>
      </template>
    </confirm-modal>
    <funnel-reject-reason-modal
      :open.sync="showRejectReasonModalFlag"
      v-if="showRejectReasonModalFlag"
      @emitRejectReason="rejectSelectedTransactions"
    />
  </div>
</template>

<script>
import _transactionsMultipleSelectHandlerMixin from '@/modules/transactions/_mixins/_transactionMultipleSelectHandlerMixin'
const Spinner = () => import('@/components/Commons/Spinner')
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')
const FunnelRejectReasonModal = () => import('@/modules/transactions/_components/funnel/FunnelRejectReasonModal.vue')

export default {
  name: 'MultipleActionsBar',
  mixins: [
    _transactionsMultipleSelectHandlerMixin
  ],
  components: {
    Spinner,
    ConfirmModal,
    FunnelRejectReasonModal
  },
  props: {
    type: {
      type: String,
      default: 'transactions'
    },
    classList: {
      type: String,
      default: ''
    },
    actionsList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isInExpenseSections () {
      return this.$route.name.includes('reimbursements')
    }
  },
  methods: {
    selectedLabel () {
      if (this.type === 'transactions') {
        return !this.selectedTransactionsBulkAction ? this.selectedTransactions.length : this.transactionsTotalItems
      } else {
        return !this.selectedTransactionsBulkAction ? this.selectedUsers.length : this.transactionsTotalItems
      }
    },
    transactionsTypeLabel () {
      if (this.type === 'transactions') {
        return this.isInExpenseSections ? this.$tc('transactions_table_total_count_and_amount_expense_type', !this.selectedTransactionsBulkAction ? this.selectedTransactions.length : this.transactionsTotalItems) : this.$tc('transactions_table_total_count_and_amount_transaction_type', !this.selectedTransactionsBulkAction ? this.selectedTransactions.length : this.transactionsTotalItems)
      } else {
        return this.$tc('transactions_table_total_count_and_amount_user_type', !this.selectedTransactionsBulkAction ? this.selectedTransactions.length : this.transactionsTotalItems)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.action-bar {
  display: flex;
  align-items: center;
  .counter-label {
    width: 290px;
    span {
      font-weight: 400;
      font-size: 15px;
      line-height: 24px;
      color: var(--text-body);
    }
  }

  .funnel-button {
    background-color: transparent;
    padding: 4px 6px 4px 4px;
    border: none;
    img {
      height: 24px;
      width: 24px;
    }
    &-label {
      font-weight: 500;
      font-size: 13px;
      line-height: 24px;
      color: var(--text-body);
    }
    &:hover {
      border-radius: 4px;
      background-color: var(--grey-action-3-hover);
    }
  }
}
.Fuell-Text.action .text-dark {
  color: var(--text-heading);
  font-weight: 500;
}
.Fuell-Text.action .text-primary {
  font-weight: 500;
}
</style>
